<template>
  <svg viewBox="0 0 46 44" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 44H0V14H10V44ZM5.002 10C2.236 10 0 7.758 0 4.998C0 2.238 2.24 0 5.002 0C7.758 0 10 2.242 10 4.998C10 7.758 7.758 10 5.002 10ZM46 44H36.386V29.4C36.386 25.918 36.32 21.44 31.388 21.44C26.382 21.44 25.612 25.232 25.612 29.148V44H16V13.978H25.228V18.08H25.358C26.642 15.72 29.78 13.232 34.46 13.232C44.2 13.232 46 19.45 46 27.534V44Z"/>
  </svg>
</template>
